<template>
  <div id="register">
    <normal-header :data="header"/>
    <div class="register-content">
      <Introduction/>
      <b-loading :is-full-page="fullPage" :active.sync="getLoadingRules"></b-loading>
      <RegisterMap/>
      <h1> {{$t('register.rules')}} </h1>
      <v-tabs v-model="active" color="rgb(10, 52, 89)" dark slider-color="#F7ac74" fixed-tabs>
        <v-tab ripple>Main Challenge</v-tab>
        <v-tab ripple>UiPath Side Challenge</v-tab>
        <v-tab ripple>BCR Side Challenge</v-tab>
        <v-tab ripple>Enevo Side Challenge</v-tab>
        <v-tab ripple>Ortec Side Challenge</v-tab>
        
        <v-tab-item>
          <Rules :rules="getRules.main"></Rules>
        </v-tab-item>
        <v-tab-item>
          <Rules :rules="getRules.uipath"></Rules>
        </v-tab-item>
        <v-tab-item>
          <Rules :rules="getRules.bcr"></Rules>
        </v-tab-item>
        <v-tab-item>
          <Rules :rules="getRules.enevo"></Rules>
        </v-tab-item>
        <v-tab-item>
          <Rules :rules="getRules.ortec"></Rules>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>

import Introduction from '@/components/registration-components/Introduction.vue';
import Rules from '@/components/registration-components/Rules.vue';
import NormalHeader from '@/components/global-components/NormalHeader'
import RegisterMap from '@/components/registration-components/RegisterMap'
import { mapGetters, mapActions } from 'vuex'

export default  {
    components: {
        Introduction,
        Rules,
        NormalHeader,
        RegisterMap
    },
  data() {
    return {
      header: {
        transparent: false
      },
      active: null,
      fullPage: true
    };
  },
  computed: {
      ...mapGetters('registerModule', ['getRules', 'getLoadingRules'])
  },
  methods: {
      ...mapActions('registerModule', ['requestRules'])

  },
  created() {
      this.requestRules();
      console.log(this.computed);
  }
};
</script>

<style lang="scss">
.v-tabs {
  min-height: 70vh;
}
</style>